/* eslint-disable no-irregular-whitespace */
import React, { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import { refsStore } from '../managers/globalState';

import '../../www/assets/css/back_button.css';
import BackButtonSVG from '../../www/assets/images/arrow-back-1-1.svg';


const BackButton = props => {
	const { customOnClick } = props;
	const { get } = useSnapshot(refsStore.state);

	const clickHandle = useCallback(() => {
		const routeManager = get('route');
		routeManager.history.goBack();
	}, [get]);

	return (
		<button className='back-btn' onClick={customOnClick || clickHandle}>
			<BackButtonSVG />
 			رجوع
		</button>
	);
};


export default BackButton;
